module.exports = __webpack_public_path__ + "static/media/4.7_preview.fab5c032.png";